
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2Zm0 18.182c-4.512 0-8.182-3.67-8.182-8.182 0-4.511 3.67-8.182 8.182-8.182 4.512 0 8.182 3.67 8.182 8.182 0 4.512-3.67 8.182-8.182 8.182Z"}}),_c('path',{attrs:{"d":"M12 6.242a1.213 1.213 0 1 0 1.212 1.213c0-.669-.544-1.213-1.212-1.213ZM12 10.485a.91.91 0 0 0-.91.909v5.455a.91.91 0 0 0 1.82 0v-5.455a.91.91 0 0 0-.91-.91Z"}})])
          )
        }
      }
    